import { render, staticRenderFns } from "./BlockedReport.vue?vue&type=template&id=48c130a8&scoped=true&"
import script from "./BlockedReport.vue?vue&type=script&lang=js&"
export * from "./BlockedReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c130a8",
  null
  
)

export default component.exports